.cartProduct {
  overflow: visible;
  padding-left: 8px;
  padding-right: 8px;
}

@media (--reefer-media-tablet-min) {
  .cartProduct {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.productDetailsContainer {
  cursor: pointer;
}

.capitalizeText {
  text-transform: capitalize;
}
